var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF335C"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.865 12.13c3.919.811 7.25 1.192 10.615 1.126v11.336a9.617 9.617 0 0 1-3.734 7.64l-6.554 5.098-6.552-5.096a9.617 9.617 0 0 1-3.736-7.64V13.257a38.01 38.01 0 0 0 9.96-1.126z",
    fill: "#FF335C",
    stroke: "#FFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.538 22.397h.445l.97-1.131-.288-.337-.682-.794H18.36c.066-.244.154-.475.262-.693.623-1.27 1.905-2.085 3.498-2.085 2.265 0 3.909 1.644 3.909 3.909 0 .39-.053.758-.144 1.106l2.697 2.697c.713.714.713 1.87 0 2.584l-.102.101a1.818 1.818 0 0 1-1.292.536c-.467 0-.935-.179-1.292-.536l-2.713-2.713c-.335.085-.69.134-1.063.134-1.593 0-2.875-.815-3.498-2.085a3.873 3.873 0 0 1-.262-.693H20.538z",
    stroke: "#FFF",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.386 27.264c.214.215.499.332.801.332.304 0 .588-.117.802-.332l.102-.102c.214-.213.332-.498.332-.801 0-.303-.118-.588-.332-.802l-2.234-2.125a3.632 3.632 0 0 1-1.715 1.695l2.244 2.135zM22.119 24.496c.165 0 .326-.014.483-.035.276-.036.54-.101.784-.197a3.018 3.018 0 0 0 1.717-1.692 3.34 3.34 0 0 0 .205-.776c.025-.172.041-.348.041-.53 0-1.872-1.358-3.231-3.23-3.231-1.18 0-2.154.54-2.714 1.407H21.302l.854.996.42.489c.01.014.016.03.026.045a.518.518 0 0 1-.027.633l-.854.996-.419.49H19.405c.56.866 1.535 1.405 2.714 1.405z",
    fill: "#FF335C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.297 25.75a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewInactive);
export default __webpack_public_path__ + "static/media/ReviewInactive.63927d39d83485b8d0cfd83d6e24686f.svg";
export { ForwardRef as ReactComponent };